<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        x-small
        label
        outlined
        color="primary"
        class="rivals-chip font-weight-bold"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon left x-small>mdi-sword-cross</v-icon>
        Rivali
      </v-chip>
    </template>
    <span>Rezultatele acestui sezon sunt folosite pentru identificarea rivalilor principali.</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'SeasonRivalryChip'
}
</script>

<style scoped>
.rivals-chip {
  vertical-align: middle;
}
</style>
